export enum Breakpoint {
  MOBILE_DOWN = '(max-width: 575px)',
  TABLET_UP = '(min-width: 576px)',
  TABLET_DOWN = '(max-width: 991px)',
  TABLET_SM_ONLY = '(min-width: 576px) and (max-width: 767px)',
  TABLET_LG_ONLY = '(min-width: 768px) and (max-width: 991px)',
  TABLET_LG_UP = '(min-width: 768px)',
  DESKTOP_UP = '(min-width: 992px)',
  DESKTOP_MD_UP = '(min-width: 1200px)',
  DESKTOP_MD_DOWN = '(max-width: 1200px)',
}
